import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Briefcase, MapPin, Wifi, ArrowUpRight, Eye, Plus } from "lucide-react";

export default function MyJobs() {
  const [jobs, setJobs] = useState([]);
  const [countries, setCountries] = useState({});

  useEffect(() => {
    api.get("/jobs/mine").then((r) => setJobs(r.data));
    api.get("/countries").then((r) => setCountries(Object.fromEntries(r.data.map((c) => [c.code, c]))));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 py-10" data-testid="my-jobs-page">
      <div className="flex justify-between items-end mb-8 flex-wrap gap-3">
        <div>
          <div className="mec-overline mb-2">Mes offres</div>
          <h1 className="font-display text-3xl font-bold text-slate-900">Vos offres publiées</h1>
        </div>
        <Link to="/jobs/new"><Button className="bg-[#004EEB] hover:bg-[#003BCC] text-white"><Plus className="w-4 h-4 mr-1.5" /> Nouvelle offre</Button></Link>
      </div>

      <div className="space-y-3">
        {jobs.length === 0 && <div className="mec-card p-12 text-center text-slate-500">Aucune offre publiée</div>}
        {jobs.map((j) => (
          <div key={j.id} className="mec-card p-6 mec-card-hover">
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex flex-wrap gap-2 mb-2">
                  <Badge variant="outline" className="font-mono text-[10px] tracking-widest uppercase border-slate-300">{j.contract_type}</Badge>
                  {j.remote && <Badge className="bg-emerald-50 text-emerald-700 hover:bg-emerald-50 border border-emerald-200"><Wifi className="w-3 h-3 mr-1" />Remote</Badge>}
                  {j.is_active ? <Badge className="bg-emerald-50 text-emerald-700 hover:bg-emerald-50 border border-emerald-200">Active</Badge> : <Badge variant="outline">Inactive</Badge>}
                </div>
                <h3 className="font-display text-xl font-semibold text-slate-900">{j.title}</h3>
                <div className="flex gap-4 text-xs text-slate-500 mt-1">
                  <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" />{countries[j.country_code]?.flag} {countries[j.country_code]?.name}</span>
                </div>
              </div>
              <div className="flex gap-2">
                <Link to={`/jobs/${j.id}`}><Button size="sm" variant="outline"><Eye className="w-4 h-4 mr-1" /> Voir</Button></Link>
                <Link to={`/jobs/${j.id}/applications`}><Button size="sm" className="bg-slate-900 hover:bg-slate-800 text-white"><Briefcase className="w-4 h-4 mr-1" /> Candidatures</Button></Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
